import { createFileRoute, Outlet } from "@tanstack/react-router";
import SiteFooter from "src/components/app/SiteFooter/SiteFooter";
import DocsLanguageProvider from "src/components/docs/DocsLanguageProvider";
import DocsNavigationSidebar from "src/components/docs/DocsNavigationSidebar";
import AppLayout from "src/components/layout/AppLayout/AppLayout";
import { preloadLazyModule } from "src/lib/LazyModules";
import { InlineRouteErrorPage } from "src/routes/-components/RouteBoundaries";
import { getDocsLayoutData } from "src/server/functions/AuthState";
import styles from "./-components/DocsLayout.module.scss";

export const Route = createFileRoute("/docs")({
  // Session, projects and the saved SDK language, loaded with the document and kept until
  // `router.invalidate()`; language changes afterwards live in DocsLanguageProvider.
  // Signed-in visitors' shell widgets (account menu, notifications, project menu) load with it;
  // signed-out visitors never download them.
  loader: async () => {
    const data = await getDocsLayoutData();
    if (data.authState?.user) await preloadLazyModule("signedInShell");
    return data;
  },
  staleTime: Number.POSITIVE_INFINITY,
  component: DocsLayout,
  errorComponent: InlineRouteErrorPage,
});

function DocsLayout() {
  const {
    authState,
    organisations,
    selectedOrgId,
    projects,
    selectedProjectId,
    projectTeam,
    moderationProfiles,
    shellData,
    initialLanguage,
    initialUiLibrary,
  } = Route.useLoaderData();
  return (
    <AppLayout
      initialProjects={projects}
      initialOrganisations={organisations}
      initialSelectedOrgId={selectedOrgId}
      initialAuthState={authState}
      initialSelectedProjectId={selectedProjectId}
      initialProjectTeam={projectTeam}
      initialModerationProfiles={moderationProfiles}
      initialShellData={shellData}
      sidebar={<DocsNavigationSidebar />}
      footer={<SiteFooter />}
    >
      {/* The page renders the article column and, beside it, the table of contents. */}
      <div className={styles.shell}>
        <DocsLanguageProvider initialLanguage={initialLanguage} initialUiLibrary={initialUiLibrary}>
          <Outlet />
        </DocsLanguageProvider>
      </div>
    </AppLayout>
  );
}
